// Selectors


import { RootState } from '../../store';

export const issuanceConfigSelector = (state: RootState) => state.issuanceConfigState
